import React from 'react'
import { useConversationWidgetContext } from '../ConversationWidget'

export const HelpLink = () => {
  const { openConversationWidget } = useConversationWidgetContext()

  return (
    <button type="button" className="btn btn-link btn-sm p-0 align-baseline" onClick={() => openConversationWidget()}>
      Click Help to start a conversation
    </button>
  )
}
